module.exports = __webpack_public_path__ + "img/goart_logo.fd67f26.png";